import { getDriverGridCellStyles } from '../../../../modules/Dispatch/RouteExecution/Drivers/Grid/styles';

interface SelectDriversTheme {
  AppBGColor?: string;
  themeName?: string;
  HeaderSelectedText?: string;
}

const styles = (theme: SelectDriversTheme) => ({
  container: {
    display: 'flex' as const,
    columnGap: 4,
    height: '92%' as const,
    flexFlow: 'nowrap' as const,
    flex: 1,
    minHeight: 0,
  },
  topGridContainer: {
    flex: '0 0 45%',
    minWidth: 0,
    display: 'flex' as const,
    flexDirection: 'column' as const,
  },
  topGridContainerMaximized: {
    flex: 1,
    display: 'flex' as const,
    flexDirection: 'column' as const,
    minWidth: 0,
  },
  topGridContainerHidden: {
    display: 'none' as const,
    height: 0,
    flex: 0,
  },
  mapContainer: {
    flex: '0 0 54%',
    minWidth: 0,
    display: 'flex' as const,
    flexDirection: 'column' as const,
    height: '100%',
    minHeight: 0,
  },
  mapContainerMaximized: {
    flex: 1,
    minWidth: 0,
    display: 'flex' as const,
    flexDirection: 'column' as const,
    height: '100%',
    minHeight: 0,
  },
  mapContainerHidden: {
    display: 'none' as const,
    height: 0,
    flex: 0,
  },
  bottomGridContainer: {
    display: 'flex' as const,
    flexDirection: 'column' as const,
    height: '100%',
  },
  mapSectionWrapper: {
    flex: 1,
    minHeight: 0,
  },
  dataGrid: {
    border: `1px solid ${theme.AppBGColor}`,
    height: '100%',
    flex: 1,
    minHeight: 0,
    [`&>.gridTheme-${theme.themeName}>.ag-theme-material.theme-${theme.themeName}`]: {
      height: '100%',
    },
    '& .statusBar': {
      display: 'none',
    },
    '& .headerCellStyle': {
      padding: '0px 8px !important',
      textAlign: 'left' as const,
      justifyContent: 'flex-start' as const,
      // Override CustomGridHeader padding so Driver # aligns with body cells
      '& [class*="customHeader"]': {
        paddingLeft: 0,
      },
    },
    '& .ag-theme-material .ag-header-select-all': {
      marginRight: '0px',
    },
    '& .ag-theme-material .ag-cell': {
      lineHeight: '20px',
    },
    '& .ag-theme-material': {
      '& .ag-row.ag-row-selected': {
        backgroundColor: 'transparent',
      },
      '& .ag-row.ag-row-selected:hover': {
        backgroundColor: 'transparent',
      },
      '& .ag-row.ag-row-selected::after': {
        display: 'none',
      },
      '& .ag-row.ag-row-selected::before': {
        display: 'none',
      },
    },
    '& .ag-theme-material .ag-icon-checkbox-checked': {
      color: theme.HeaderSelectedText,
    },
    '& .ag-center-cols-viewport': {
      overflowX: 'auto',
    },
    '& .pickupNameCellClass': {
      padding: '0px 10px !important',
    },
    '& .gridCell-alignCenter': {
      alignItems: 'center',
      display: 'flex',
    },
    // Reuse Driver Status & cell renderer styles from Dispatch Drivers Grid
    ...getDriverGridCellStyles(theme),
  },
});

export default styles;
